import Header from "./Header.vue";
import HeaderComponents from "./Components";

export default {
  install(Vue) {
    Vue.use(HeaderComponents);
    Vue.component("fp-app-header", Header);
  },
};
